const prefix = "DASHBOARD_";

export const ACTIVITY_FOR_WEEK_GET_FAILED = prefix + "ACTIVITY_FOR_WEEK_GET_FAILED";
export const ACTIVITY_FOR_WEEK_GET_STARTED = prefix + "ACTIVITY_FOR_WEEK_GET_STARTED";
export const ACTIVITY_FOR_WEEK_GET_SUCCEEDED = prefix + "ACTIVITY_FOR_WEEK_GET_SUCCEEDED";
export const ACTIVITY_FOR_YEAR_GET_FAILED = prefix + "ACTIVITY_FOR_YEAR_GET_FAILED";
export const ACTIVITY_FOR_YEAR_GET_STARTED = prefix + "ACTIVITY_FOR_YEAR_GET_STARTED";
export const ACTIVITY_FOR_YEAR_GET_SUCCEEDED = prefix + "ACTIVITY_FOR_YEAR_GET_SUCCEEDED";
export const INVOICE_STATUS_GET_FAILED = prefix + "INVOICE_STATUS_GET_FAILED";
export const INVOICE_STATUS_GET_STARTED = prefix + "INVOICE_STATUS_GET_STARTED";
export const INVOICE_STATUS_GET_SUCCEEDED = prefix + "INVOICE_STATUS_GET_SUCCEEDED";
export const LEVY_COMPONENTS_GET_FAILED = prefix + "LEVY_COMPONENTS_GET_FAILED";
export const LEVY_COMPONENTS_GET_STARTED = prefix + "LEVY_COMPONENTS_GET_STARTED";
export const LEVY_COMPONENTS_GET_SUCCEEDED = prefix + "LEVY_COMPONENTS_GET_SUCCEEDED";
export const NOTICE_COUNTS_GET_FAILED = prefix + "NOTICE_COUNTS_GET_FAILED";
export const NOTICE_COUNTS_GET_STARTED = prefix + "NOTICE_COUNTS_GET_STARTED";
export const NOTICE_COUNTS_GET_SUCCEEDED = prefix + "NOTICE_COUNTS_GET_SUCCEEDED";
export const PAYMENT_STATUS_GET_FAILED = prefix + "PAYMENT_STATUS_GET_FAILED";
export const PAYMENT_STATUS_GET_STARTED = prefix + "PAYMENT_STATUS_GET_STARTED";
export const PAYMENT_STATUS_GET_SUCCEEDED = prefix + "PAYMENT_STATUS_GET_SUCCEEDED";
export const PROVIDER_LEVY_AMOUNTS_GET_FAILED = prefix + "PROVIDER_LEVY_AMOUNTS_GET_FAILED";
export const PROVIDER_LEVY_AMOUNTS_GET_STARTED = prefix + "PROVIDER_LEVY_AMOUNTS_GET_STARTED";
export const PROVIDER_LEVY_AMOUNTS_GET_SUCCEEDED = prefix + "PROVIDER_LEVY_AMOUNTS_GET_SUCCEEDED";
export const PROVIDER_STATUS_GET_FAILED = prefix + "PROVIDER_STATUS_GET_FAILED";
export const PROVIDER_STATUS_GET_STARTED = prefix + "PROVIDER_STATUS_GET_STARTED";
export const PROVIDER_STATUS_GET_SUCCEEDED = prefix + "PROVIDER_STATUS_GET_SUCCEEDED";
export const STATE_RESET = prefix + "STATE_RESET";
export const STATE_UNLOAD = prefix + "STATE_UNLOAD";
